import React from "react";
import { Box, Typography } from "@mui/material";

const ChartImageExportCard = ({
  title,
  subtitle = "",
  headerRows = [],
  detailRows = [],
  logoSrc = "/img/ac_black_logo.png",
  children,
}) => {
  return (
    <Box
      sx={{
        width: "2000px",
        minHeight: "1220px",
        backgroundColor: "#fff",
        color: "#111",
        px: 7,
        py: 6,
        display: "flex",
        flexDirection: "column",
        gap: 4,
      }}
    >
      <Box sx={{ textAlign: "center" }}>
        <Typography sx={{ fontSize: 28, fontWeight: 700 }}>
          {title}
        </Typography>
        {subtitle ? (
          <Typography sx={{ mt: 1, fontSize: 20, fontWeight: 600 }}>
            {subtitle}
          </Typography>
        ) : null}
      </Box>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          gap: 6,
          alignItems: "stretch",
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>{children}</Box>

        <Box
          sx={{
            width: 430,
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            gap: 4,
          }}
        >
          <Box>
            {headerRows.map((row) => (
              <Typography
                key={row.label}
                sx={{ fontSize: 18, fontWeight: 700, mb: 2.5 }}
              >
                {row.label}: <span style={{ fontWeight: 400 }}>{row.value}</span>
              </Typography>
            ))}

            <Box component="ul" sx={{ listStyle: "disc", pl: 3, m: 0 }}>
              {detailRows.map((row) => (
                <Box component="li" key={row.label} sx={{ mb: 2.5 }}>
                  <Typography component="span" sx={{ fontSize: 18, fontWeight: 700 }}>
                    {row.label}:
                  </Typography>{" "}
                  <Typography component="span" sx={{ fontSize: 18 }}>
                    {row.value}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <img
              src={logoSrc}
              alt="Action Cards"
              style={{ width: 430, height: "auto", objectFit: "contain" }}
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ChartImageExportCard;
